
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carrier/tms",
      function () {
        return require("private-next-pages/carrier/tms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carrier/tms"])
      });
    }
  